import { Route } from '@angular/router';
import { CompaniesComponent } from 'src/app/pages/company/companies/companies.component';
import { CompanyDetailsAreasComponent } from 'src/app/pages/company/company-details/company-details-areas/company-details-areas.component';
import { CompanyDetailsAttributesComponent } from 'src/app/pages/company/company-details/company-details-attributes/company-details-attributes.component';
import { CompanyDetailsCampaignsComponent } from 'src/app/pages/company/company-details/company-details-campaigns/company-details-campaigns.component';
import { CompanyDetailsCullsComponent } from 'src/app/pages/company/company-details/company-details-culls/company-details-culls.component';
import { CompanyDetailsLocationsComponent } from 'src/app/pages/company/company-details/company-details-locations/company-details-locations.component';
import { CompanyDetailsMediaComponent } from 'src/app/pages/company/company-details/company-details-media/company-details-media.component';
import { CompanyDetailsMediumGroupsComponent } from 'src/app/pages/company/company-details/company-details-medium-groups/company-details-medium-groups.component';
import { CompanyDetailsOverviewComponent } from 'src/app/pages/company/company-details/company-details-overview/company-details-overview.component';
import { CompanyDetailsComponent } from 'src/app/pages/company/company-details/company-details.component';
import { CompanyEditComponent } from 'src/app/pages/company/company-edit/company-edit.component';
import { CompanyLevelComponent } from 'src/app/pages/company/company-level/company-level.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const companies: Route = {
  path: 'companies',
  title: 'nav.companies',
  data: {
    breadcrumb: 'nav.companies',
    icon: SbIcons.company,
    id: RoutingID.companies,
  },
  children: [
    {
      path: '',
      component: CompaniesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'company-levels/:companyID',
      title: 'nav.companies.levels',
      data: {
        breadcrumb: 'nav.companies.levels',
        id: RoutingID.companyLevel,
        icon: SbIcons.level,
      },
      children: [
        {
          path: '',
          component: CompanyLevelComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'company-edit/:companyID',
      title: 'nav.companies.edit',
      data: {
        breadcrumb: 'nav.companies.edit',
        icon: SbIcons.edit,
        id: RoutingID.companyEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: CompanyEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'company-details/:companyID',
      title: 'nav.network.companies.details',
      data: {
        breadcrumb: 'nav.network.companies.details',
        icon: SbIcons.details,
        id: RoutingID.companyDetails,
      },
      children: [
        {
          path: '',
          component: CompanyDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'company-details-overview',
              component: CompanyDetailsOverviewComponent,
              title: 'nav.network.companies.details.overview',
              data: {
                breadcrumb: 'nav.network.companies.details.overview',
                icon: SbIcons.eye,
                id: RoutingID.companyDetailsOverview,
              },
            },
            {
              path: 'company-details-attributes',
              component: CompanyDetailsAttributesComponent,
              title: 'nav.network.companies.details.attributes',
              data: {
                breadcrumb: 'nav.network.companies.details.attributes',
                icon: SbIcons.attributes,
                id: RoutingID.companyDetailsAttributes,
              },
            },
            {
              path: 'company-details-locations',
              component: CompanyDetailsLocationsComponent,
              title: 'nav.network.companies.details.locations',
              data: {
                breadcrumb: 'nav.network.companies.details.locations',
                icon: SbIcons.locationStreet,
                id: RoutingID.companyDetailsLocations,
              },
            },
            {
              path: 'company-details-campaigns',
              component: CompanyDetailsCampaignsComponent,
              title: 'nav.network.companies.details.campaigns',
              data: {
                breadcrumb: 'nav.network.companies.details.campaigns',
                icon: SbIcons.megaphone,
                id: RoutingID.companyDetailsCampaigns,
              },
            },
            {
              path: 'company-details-media',
              component: CompanyDetailsMediaComponent,
              title: 'nav.network.companies.details.media',
              data: {
                breadcrumb: 'nav.network.companies.details.media',
                icon: SbIcons.motive,
                id: RoutingID.companyDetailsMedia,
              },
            },
            {
              path: 'company-details-mediumgroups',
              component: CompanyDetailsMediumGroupsComponent,
              title: 'nav.network.companies.details.mediumgroups',
              data: {
                breadcrumb: 'nav.network.companies.details.mediumgroups',
                icon: SbIcons.motives,
                id: RoutingID.companyDetailsMediumgroups,
              },
            },
            {
              path: 'company-details-areas',
              component: CompanyDetailsAreasComponent,
              title: 'nav.network.companies.details.areas',
              data: {
                breadcrumb: 'nav.network.companies.details.areas',
                icon: SbIcons.globe,
                id: RoutingID.companyDetailsAreas,
              },
            },
            {
              path: 'company-details-culls',
              component: CompanyDetailsCullsComponent,
              title: 'nav.network.companies.details.culls',
              data: {
                breadcrumb: 'nav.network.companies.details.culls',
                icon: SbIcons.filter,
                id: RoutingID.companyDetailsCulls,
              },
            },
            { path: '', redirectTo: RoutingID.companyDetailsOverview, pathMatch: 'full' },
          ],
        },
      ],
    },
    {
      path: 'company-create',
      title: 'nav.companies.create',
      data: {
        breadcrumb: 'nav.companies.create',
        icon: SbIcons.plus,
        id: RoutingID.companyCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: CompanyEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
